import {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {Select} from 'shipwell-ui';
import SchedulePickups from 'App/components/parcelPickups';
import {getUPSRegistrationAccounts} from 'App/containers/ups/actions/async';
import ShipwellLoader from 'App/common/shipwellLoader/index';

/**
 * UPS Account Details
 * @param {*} props
 */
const UPSAccountDetails = (props) => {
  const {dispatch, isEditable} = props;

  // Data states
  const [isFetchingUPSAccounts, setIsFetchingUPSAccounts] = useState(true);
  const [upsAccounts, setUPSAccounts] = useState([]);
  const [upsAccount, setUPSAccount] = useState(null);

  /**
   * Request UPS accounts
   */
  const fetchUPSRegistrationAccounts = async () => {
    try {
      const response = await dispatch(getUPSRegistrationAccounts());

      if (response && response.body && response.body.results.length) {
        setUPSAccounts(response.body.results);
        setUPSAccount(response.body.results[0]);
      }
    } catch (error) {
      console.error(error);
    }
    setIsFetchingUPSAccounts(false);
  };

  /** Set UPS account from select field */
  const handleUPSAccountSelection = (selectedAccount) => {
    setUPSAccount(selectedAccount);
  };

  /** Get UPS registered accounts on mount */
  useEffect(() => {
    // Fetch UPS accounts
    if (!upsAccounts.length) {
      fetchUPSRegistrationAccounts();
    }
  }, []);

  return (
    <div>
      {isFetchingUPSAccounts && !upsAccount && <ShipwellLoader loading />}
      {!isFetchingUPSAccounts && upsAccount && (
        <div className="ups-account-container field-grid">
          <div className="grid-item-1">
            <Select
              clearable={false}
              label="UPS Account ID"
              name="ups_account"
              getOptionLabel={({account_number}) => account_number}
              getOptionValue={({id}) => id}
              value={upsAccount}
              options={upsAccounts}
              onChange={handleUPSAccountSelection}
              disabled={!isEditable}
            />
          </div>
          {upsAccount && (
            <div className="grid-item-2 ups-account-details">
              <SchedulePickups account={upsAccount} providerCode="UPS" />
            </div>
          )}
        </div>
      )}
      {!isFetchingUPSAccounts && upsAccounts.length < 1 && <p>No UPS Account Connected</p>}
    </div>
  );
};

export default connect()(UPSAccountDetails);
